import { useState } from 'react';
import { HandFist, HandPalm, Scissors } from '@phosphor-icons/react';
import { Button } from '../ui/button';

const MOVES = [
  { id: 'rock', label: 'Rock', Icon: HandFist },
  { id: 'paper', label: 'Paper', Icon: HandPalm },
  { id: 'scissors', label: 'Scissors', Icon: Scissors }
];

const BEATS = { rock: 'scissors', paper: 'rock', scissors: 'paper' };

export function RockPaperScissors({ onScore }) {
  const [streak, setStreak] = useState(0);
  const [best, setBest] = useState(0);
  const [round, setRound] = useState(null);

  const play = (playerMove) => {
    const aiMove = MOVES[Math.floor(Math.random() * 3)].id;
    let result = 'draw';
    if (BEATS[playerMove] === aiMove) result = 'win';
    else if (BEATS[aiMove] === playerMove) result = 'lose';

    setRound({ playerMove, aiMove, result });

    if (result === 'win') {
      const next = streak + 1;
      setStreak(next);
      if (next > best) setBest(next);
    } else if (result === 'lose') {
      if (streak > 0) onScore(streak);
      setStreak(0);
    }
  };

  return (
    <div className="space-y-5" data-testid="game-rock-paper-scissors">
      <div className="flex items-center justify-between text-sm">
        <span>Win streak: <span className="text-amber-300 tabular-nums" data-testid="rps-streak">{streak}</span></span>
        <span className="text-muted-foreground">Best this session: {best}</span>
      </div>

      <div className="grid grid-cols-3 gap-3">
        {MOVES.map(({ id, label, Icon }) => (
          <button
            key={id}
            type="button"
            onClick={() => play(id)}
            className="flex flex-col items-center gap-2 py-5 rounded-lg border border-white/10 bg-white/5 hover:bg-amber-400/10 hover:border-amber-400/40 transition-colors"
            data-testid={`rps-move-${id}`}
          >
            <Icon size={30} weight="duotone" className="text-amber-300" />
            <span className="text-xs">{label}</span>
          </button>
        ))}
      </div>

      {round && (
        <div className="text-center space-y-1" data-testid="rps-result">
          <p className="text-sm text-muted-foreground">
            You played <span className="text-white">{round.playerMove}</span> · AI played <span className="text-white">{round.aiMove}</span>
          </p>
          <p className={`text-lg font-light ${round.result === 'win' ? 'text-emerald-400' : round.result === 'lose' ? 'text-rose-400' : 'text-amber-300'}`}>
            {round.result === 'win' ? 'You win this round!' : round.result === 'lose' ? 'AI takes it. Streak reset.' : "It's a draw."}
          </p>
        </div>
      )}

      <Button
        variant="outline"
        className="rounded-full w-full"
        onClick={() => { if (streak > 0) onScore(streak); setStreak(0); setRound(null); }}
        data-testid="rps-bank-streak"
      >
        Bank streak &amp; reset
      </Button>
    </div>
  );
}
